import React, { useState } from "react";
import { Button, MenuItem } from "@mui/material";
import { NavLink } from "react-router-dom";

import { List_options } from "./List_options";

export const Menu_items = ({ label, to, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <li className="menu_items_li">
      <List_options anchorEl={anchorEl} open={open} handleClose={handleClose}>
        {options?.map((option) => (
          <NavLink
            key={option.label}
            to={option.goto}
            style={{
              textDecoration: "none",
              color: "#3d3d3d",
            }}
            className={(isActive) => (isActive ? "active" : "inactive")}
          >
            <MenuItem key={option.label} onClick={handleClose}>
              {option.label}
            </MenuItem>
          </NavLink>
        ))}
      </List_options>

      <Button variant="text" onClick={handleClick}>
        {label}
      </Button>
    </li>
  );
};
